var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33887 22.6535L7.57938 77.1696L82.4389 65.8208L72.1992 13.4087L4.33887 22.6535Z",
    fill: "#18181B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1831 67.0496L6.20133 78.8718L2.78369 21.3753L73.3807 11.7576L84.1831 67.0496ZM5.89363 23.9317L8.95695 75.4675L80.6943 64.5919L71.0172 15.0597L5.89363 23.9317Z",
    fill: "#18181B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.276 72.9272L17.4458 79.0504L30.3536 77.193L28.9756 71.4064L18.276 72.9272Z",
    fill: "#18181B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1641 78.424L15.7197 80.7903L16.9628 71.6226L30.0998 69.7553L32.1641 78.424ZM19.5888 74.2318L19.1714 77.3104L28.5424 75.9619L27.8507 73.0574L19.5888 74.2318Z",
    fill: "#18181B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8503 65.3124L74.0578 70.7736L59.9956 73.3324L60.2201 66.9654L71.8503 65.3124Z",
    fill: "#18181B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1062 71.9015L58.4556 75.1133L58.7883 65.6777L72.7864 63.6881L76.1062 71.9015ZM61.652 68.2531L61.5358 71.5515L72.0095 69.6457L70.9145 66.9366L61.652 68.2531Z",
    fill: "#18181B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76172 22.3235L11.2085 73.9906L82.0675 63.9191L72.1993 13.4087L6.76172 22.3235Z",
    fill: "#93C5FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2407 27.6226L66.1574 20.3756L72.8732 58.2274L17.684 66.5765L14.2407 27.6226Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8148 65.162L9.8715 75.6718L5.17041 21.0502L73.3811 11.7576L83.8148 65.162ZM8.35323 23.5966L12.5458 72.3092L80.3204 62.6761L71.0176 15.0597L8.35323 23.5966Z",
    fill: "#18181B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7557 56.103C54.1167 56.103 60.0841 50.1357 60.0841 42.7746C60.0841 35.4135 54.1167 29.4462 46.7557 29.4462C39.3946 29.4462 33.4272 35.4135 33.4272 42.7746C33.4272 50.1357 39.3946 56.103 46.7557 56.103Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7557 56.103C54.1167 56.103 60.0841 50.1357 60.0841 42.7746C60.0841 35.4135 54.1167 29.4462 46.7557 29.4462C39.3946 29.4462 33.4272 35.4135 33.4272 42.7746C33.4272 50.1357 39.3946 56.103 46.7557 56.103Z",
    fill: "#93C5FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.608 42.7746C58.608 36.2289 53.3016 30.9226 46.756 30.9226C40.2103 30.9226 34.904 36.2289 34.904 42.7746C34.904 49.3203 40.2103 54.6266 46.756 54.6266C53.3016 54.6266 58.608 49.3203 58.608 42.7746ZM61.5608 42.7746C61.5608 50.951 54.9324 57.5795 46.756 57.5795C38.5795 57.5794 31.9512 50.951 31.9512 42.7746C31.9512 34.5981 38.5795 27.9698 46.756 27.9698C54.9324 27.9698 61.5608 34.5981 61.5608 42.7746Z",
    fill: "#18181B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.892 42.7746C51.892 39.938 49.5925 37.6385 46.7559 37.6385C43.9194 37.6385 41.6199 39.938 41.6199 42.7746C41.6199 45.6112 43.9194 47.9107 46.7559 47.9107C49.5925 47.9107 51.892 45.6112 51.892 42.7746ZM54.0011 42.7746C54.0011 46.776 50.7574 50.0198 46.7559 50.0198C42.7545 50.0198 39.5107 46.776 39.5107 42.7746C39.5107 38.7732 42.7545 35.5294 46.7559 35.5294C50.7574 35.5294 54.0011 38.7732 54.0011 42.7746Z",
    fill: "#18181B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.892 42.7746C51.892 39.938 49.5925 37.6385 46.7559 37.6385C43.9194 37.6385 41.6199 39.938 41.6199 42.7746C41.6199 45.6112 43.9194 47.9107 46.7559 47.9107C49.5925 47.9107 51.892 45.6112 51.892 42.7746ZM54.0011 42.7746C54.0011 46.776 50.7574 50.0198 46.7559 50.0198C42.7545 50.0198 39.5107 46.776 39.5107 42.7746C39.5107 38.7732 42.7545 35.5294 46.7559 35.5294C50.7574 35.5294 54.0011 38.7732 54.0011 42.7746Z",
    fill: "#18181B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6655 36.4048L44.587 36.7631L43.3916 29.8278L45.47 29.4695L46.6655 36.4048Z",
    fill: "#18181B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1879 38.3343L40.9715 40.0574L35.2222 35.9987L36.4386 34.2757L42.1879 38.3343Z",
    fill: "#18181B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7443 44.9433L33.809 46.1388L33.4507 44.0603L40.386 42.8649L40.7443 44.9433Z",
    fill: "#18181B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0386 48.559L39.9799 54.3082L38.2568 53.0918L42.3155 47.3425L44.0386 48.559Z",
    fill: "#18181B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1201 55.7214L48.0416 56.0797L46.8462 49.1444L48.9246 48.7861L50.1201 55.7214Z",
    fill: "#18181B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2894 49.5505L57.073 51.2736L51.3237 47.2149L52.5401 45.4919L58.2894 49.5505Z",
    fill: "#18181B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0607 41.4889L53.1254 42.6843L52.7671 40.6058L59.7024 39.4104L60.0607 41.4889Z",
    fill: "#18181B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2549 32.4574L51.1962 38.2067L49.4731 36.9903L53.5318 31.241L55.2549 32.4574Z",
    fill: "#18181B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2229 59.1964L16.6368 67.9081L12.9878 26.6261L67.1039 19.0722L74.2229 59.1964ZM15.4929 28.6189L18.7305 65.2449L71.5228 57.2584L65.2101 21.679L15.4929 28.6189Z",
    fill: "#18181B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9691 58.1502L24.6591 58.3666L22.373 33.9635L24.683 33.7471L26.9691 58.1502Z",
    fill: "#18181B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8594 34.795L20.8179 35.569L20.5229 33.2677L26.5646 32.4937L26.8594 34.795Z",
    fill: "#18181B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3008 59.0221L23.2593 59.796L22.9644 57.4948L29.006 56.7207L29.3008 59.0221Z",
    fill: "#18181B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.174 72.7162L19.3438 78.8395L32.2515 76.9821L30.8735 71.1955L20.174 72.7162Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0626 78.2131L17.6182 80.5794L18.8612 71.4117L31.9982 69.5444L34.0626 78.2131ZM21.4872 74.0208L21.0698 77.0995L30.4409 75.751L29.7492 72.8465L21.4872 74.0208Z",
    fill: "#18181B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7489 65.1014L75.9563 70.5627L61.9077 72.7366L62.1186 66.7545L73.7489 65.1014Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0231 71.7368L60.3691 74.4686L60.6865 65.4668L74.6846 63.4772L78.0231 71.7368ZM63.5503 68.0421L63.4459 71.0045L73.889 69.3886L72.8127 66.7257L63.5503 68.0421Z",
    fill: "#18181B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4504 9.19118L24.864 14.4092L24.478 11.4818L64.0646 6.26378L64.4504 9.19118Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundsIcon);
export default __webpack_public_path__ + "static/media/fundsIcon.cc6407edfc5f84ef9ce367f074ad66cb.svg";
export { ForwardRef as ReactComponent };